import { z } from 'zod'
import { Model } from './architecture'

export const ImageBucketValidation = z.object({
  value: z.string({ required_error: '[ImageBucket] value is required' }),
})

export class ImageBucket extends Model {
  static create({ value }: z.infer<typeof ImageBucketValidation>) {
    ImageBucketValidation.parse({ value })
    return new ImageBucket(value)
  }

  constructor(private readonly _value: string) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  toJSON() {
    return { value: this.value }
  }
}
